import { withTweekKeys } from 'react-tweek';
import { compose } from 'recompose';

import { PATHS, PageId } from '../constants';
import AddDevices from '../pages/add-devices';
import AuthPages from '../pages/auth';
import FaqPage from '../pages/faqpage';
import HomePage from '../pages/homepage';
import NotFound from '../pages/notfound';
import profileRoutes from '../pages/profile/routes';
import TermsPage from '../pages/termspage';
import WhatsCoveredPage from '../pages/whats-covered';
import { getPath } from '../utils';
import { RouteComponent } from './models';
import { composePage, withFooterConfig, withHeaderConfig } from './utils';
import getPartnerAsset, { DynamicAssetsKeys } from '../assets';
import { partnerValue } from '../partner';
import { getTabUrl, getUrl } from '../pages/profile/utils';
import FeesAndDeductiblesPage from '../pages/fees-and-deductibles';

const termsLinkTo = getPartnerAsset(DynamicAssetsKeys.finePrintLinkTo);
const termsLinkLabel = getPartnerAsset(DynamicAssetsKeys.finePrintLinkLabel);

export const externalRedirects = require(`./${globals.REACT_APP_PARTNER}`).externalRedirects || [];

export const internalRedirects = (require(`./${globals.REACT_APP_PARTNER}`).internalRedirects || []).concat([
  {
    route: { exact: true, path: '/1' },
    toPath: getPath(PATHS.signup, 1),
  },
]);

const commonRoutes: RouteComponent[] = [
  {
    Component: composePage(
      { pageId: PageId.Homepage },
      withTweekKeys({
        competitors: 'soluto_home_web/smart_home_support/calculator/competitors/_',
        devices: 'soluto_home_web/smart_home_support/calculator/devices/_',
      })
    )(HomePage),
    route: { exact: true, path: '/' },
  },
  {
    Component: compose(
      withTweekKeys(
        { isEnabled: 'soluto_home_web/smart_home_support/auth/is_enabled' },
        {
          defaultValues: { isEnabled: true },
        }
      )
    )(AuthPages),
    title: { isOverridden: true },
    route: { path: `/${PATHS.auth}` },
  },
  {
    Component: composePage({ pageId: PageId.FAQ })(FaqPage),
    route: { exact: true, path: '/faq' },
    title: 'Frequently Asked Questions',
  },
  {
    Component: composePage({ pageId: PageId.TermsAndConditions })(TermsPage),
    route: { exact: true, path: termsLinkTo },
    title: partnerValue({ Asurion: termsLinkLabel }, 'Terms and Conditions'),
  },
  {
    Component: composePage({ pageId: PageId.WhatsCovered }, withHeaderConfig({ backTo: '/' }))(WhatsCoveredPage),
    route: { exact: true, path: '/whats-covered' },
    title: "What's Covered",
  },
  {
    Component: composePage(
      { pageId: PageId.FeesAndDeductibles },
      withHeaderConfig({ backTo: '/whats-covered' })
    )(FeesAndDeductiblesPage),
    route: { exact: true, path: '/fees-and-deductibles' },
    title: 'Fees And Deductibles',
  },
  {
    Component: composePage(
      { pageId: PageId.AddDevices },
      withHeaderConfig({ isNavigable: false, isLogoLinked: false, hideExpertChat: true }),
      withTweekKeys({ devices: 'soluto_home_web/smart_home_support/calculator/devices/_' }),
      withFooterConfig({ type: 'hidden' })
    )(AddDevices),
    route: { exact: true, path: '/add-devices' },
    title: 'Add Devices',
  },
  ...profileRoutes,
];

const partnerRoutes: RouteComponent[] = require(`./${globals.REACT_APP_PARTNER}`).default;

const notFoundPageAsLastRoute: RouteComponent[] = [
  {
    Component: composePage({ pageId: PageId.NotFound })(NotFound),
    route: {},
  },
];

export default partnerRoutes.concat(commonRoutes).concat(notFoundPageAsLastRoute);



// WEBPACK FOOTER //
// ./packages/smart-home-support/routes/index.ts